import { postTicket } from '../../api/TICKET/ticket';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const usePostTicket = () => {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: postTicket,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['tickets'] });
        queryClient.invalidateQueries({ queryKey: ['ticketsClient'] });
      },
    });
  };
  